import script from "./caseDetail.vue?vue&type=script&setup=true&name=caseDetail&lang=js"
export * from "./caseDetail.vue?vue&type=script&setup=true&name=caseDetail&lang=js"

import "./caseDetail.vue?vue&type=style&index=0&id=45b83868&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b83868"]])

export default __exports__